import { render, staticRenderFns } from "./CustomAssigner.vue?vue&type=template&id=272da39c&scoped=true&"
import script from "./CustomAssigner.vue?vue&type=script&lang=js&"
export * from "./CustomAssigner.vue?vue&type=script&lang=js&"
import style0 from "./CustomAssigner.vue?vue&type=style&index=0&id=272da39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272da39c",
  null
  
)

export default component.exports